// Tham số trên URL của /customer-chats.
//
// `section`: nút "Trao đổi" ở trang Người giới thiệu nhảy thẳng vào mục đối tác
// (/customer-chats?section=partners, spec 22/08/2026 §9.4).
//
// `thread` = luồng đang mở (QĐ 0223): thông báo chuông "được giao khách", "đến
// giờ hẹn", "nhắc tên" trỏ /customer-chats?thread=<mã luồng>; nằm trên URL nên
// nút quay lại của điện thoại đưa về danh sách thay vì rời trang.
export type CustomerChatsSearch = {
  section?: "customers" | "partners" | undefined;
  thread?: string | undefined;
};

// Mã luồng là uuid — chuỗi lạ (dán tay, link hỏng) bỏ đi luôn, khỏi gọi máy chủ
// để ăn 400.
const THREAD_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function parseCustomerChatsSearch(search: Record<string, unknown>): CustomerChatsSearch {
  return {
    section: search.section === "partners" || search.section === "customers" ? search.section : undefined,
    thread: typeof search.thread === "string" && THREAD_ID.test(search.thread) ? search.thread : undefined,
  };
}
